import { createContext } from "react";

import { IModals, IUseModals } from "store/types/modals";

export const modalsInitialState: IModals = {
  successModal: null,
  errorModal: null,
  warningModal: null,
  infoModal: null,
  noticeModal: null,

  deleteModal: null,
  createModal: null,

  deleteFileModal: null,
  investorModal: { isOpen: false },
  investorVisualizationModal: { isOpen: false, dealId: 0 },
  confirmModal: null,
  expiredPasswordModal: { isShow: false, onContinue: () => {} },
  imagePreviewModal: { src: "" },
  sendUsQuestion: false,
  pdfTaggerErrorModal: null,
  dataroomConnect: { isOpen: false },
  upgradeAccount: false,
  upgradePlanModal: false,
  dataroomInfoConnect: { isOpen: false },
  irrGraphModalOpen: false,
  selectDealFolderModal: { isOpen: false, title: "", onSubmit: () => {} },
  emailInboxModal: null,
  bankPercentageModal: null,
  filesUploadModal: null
};

export const ModalsContext = createContext<IUseModals>({} as IUseModals);
